export default __webpack_public_path__ + "static/media/kycVerificationhelpHighlight@2x.d8648100.png";